import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../components/Breadcrumb';
import { FilterBar } from '../components/FilterBar';
import { OfferCard } from '../components/OfferCard';
import { findCategoryByPath, buildBreadcrumb } from '../data/categories';
import { mockOffers } from '../data/mockData';
import { ArrowLeft } from 'lucide-react';
export function ProductListingPage() {
  const {
    '*': pathParam
  } = useParams();
  const navigate = useNavigate();
  const slugs = pathParam?.split('/').filter(Boolean) || [];
  const category = findCategoryByPath(slugs);
  const breadcrumb = buildBreadcrumb(slugs);
  if (!category) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-459">
        <div className="text-center" data-id="element-460">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-461">
            Category Not Found
          </h1>
          <button onClick={() => navigate('/explore')} className="text-kithward-700 font-bold hover:underline" data-id="element-462">
            Return to Explore
          </button>
        </div>
      </div>;
  }
  // Filter offers by category (simplified - in real app, would use categoryPath)
  const filteredOffers = mockOffers.filter(offer => {
    // Match first slug to offer category
    const mainCategory = slugs[0];
    if (mainCategory === 'adaptive-clothing') return offer.category === 'clothing';
    if (mainCategory === 'hearing-health') return offer.category === 'health';
    if (mainCategory === 'mobility') return offer.category === 'mobility';
    if (mainCategory === 'home-safety') return offer.category === 'home';
    return true;
  });
  return <div className="min-h-screen bg-gray-50 pb-32" data-id="element-463">
      <div className="bg-white pt-8 pb-4 px-4 md:px-8 border-b border-gray-200" data-id="element-464">
        <div className="max-w-7xl mx-auto" data-id="element-465">
          {/* Back Button */}
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-600 hover:text-kithward-700 mb-6 transition-colors" data-id="element-466">
            <ArrowLeft className="w-5 h-5" data-id="element-467" />
            <span className="font-medium" data-id="element-468">Back</span>
          </button>

          {/* Breadcrumb */}
          <Breadcrumb items={breadcrumb} data-id="element-469" />

          {/* Page Title */}
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-2" data-id="element-470">
            {category.name}
          </h1>
          <p className="text-gray-500 text-lg mb-6" data-id="element-471">
            {filteredOffers.length} offers available
          </p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="px-4 md:px-8" data-id="element-472">
        <div className="max-w-7xl mx-auto" data-id="element-473">
          <FilterBar data-id="element-474" />
        </div>
      </div>

      {/* Product Grid */}
      <div className="px-4 md:px-8" data-id="element-475">
        <div className="max-w-7xl mx-auto" data-id="element-476">
          {filteredOffers.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-477">
              {filteredOffers.map(offer => <OfferCard key={offer.id} offer={offer} data-id="element-478" />)}
            </div> : <div className="text-center py-20 bg-white rounded-2xl border border-gray-100" data-id="element-479">
              <p className="text-gray-500 text-lg mb-4" data-id="element-480">
                No products found in this category yet.
              </p>
              <button onClick={() => navigate('/explore')} className="text-kithward-700 font-bold hover:underline" data-id="element-481">
                Browse all categories
              </button>
            </div>}
        </div>
      </div>
    </div>;
}